import { render, staticRenderFns } from "./InputWithSuggestions.vue?vue&type=template&id=f3f9a058&scoped=true&"
import script from "./InputWithSuggestions.vue?vue&type=script&lang=js&"
export * from "./InputWithSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./InputWithSuggestions.vue?vue&type=style&index=0&id=f3f9a058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f9a058",
  null
  
)

export default component.exports